import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel'
import '@esri/calcite-components/dist/components/calcite-action-group';
import PoleItem from '@/utils/pole-item';
import PoleLink from '@/utils/pole-link';

// 定数
const LOGH = 'BFA10104G map link:';

/**
 * 径間選択モデル作成
 */
export function linkSelectSketchModel(view, layers) {
  const sketch = new SketchViewModel({
    view: view,
    layer: layers.linker,

    // 選択モード継続
    creationMode: 'continuous',

    // スナップ設定
    snappingOptions: {
      enabled: true,
      distance: 20,
      featureEnabled: true,
      featureSources: [
        { enabled: true, layer: layers.setubi },
        { enabled: true, layer: layers.pole },
        { enabled: true, layer: layers.master },
      ],
      selfEnabled: false,
    },

    // 未使用と思われる設定を無効化
    updateOnGraphicClick: false,
    highlightOptions: { enabled: false },
  });
  return sketch;
}

/**
 * 径間選択イベント処理
 */
export async function linkSelectHandler({
  event,
  sketch, layers,
  propValues, setSelectMode
}) {
  const { itemSelected, onItemSelect } = propValues.current;

  // 選択開始
  if (event.state === 'start') {
    const paths = event.graphic?.geometry?.paths?.at(0);
    console.debug(LOGH, '径間選択開始', paths?.length);

    // 現在の選択電柱/径間を解除
    sketch.layer.removeAll();
    itemSelected && onItemSelect(null);
  }

  // 電柱選択 (state: start or active)
  if (event.toolEventInfo?.type === 'vertex-add') {
    const paths = event.graphic?.geometry?.paths?.at(0);
    console.debug(LOGH, '径間電柱選択', paths?.length);

    // ヒットテスト
    const attr = await hitTest(sketch, layers, paths?.at(-1));

    // 径間を選んだら選択終了
    if (attr?.link) {
      console.info(LOGH, '径間選択', attr.link);
      onItemSelect('link', attr.link, { from: 'map' });
      sketch.complete();
      return;
    }

    // 電柱でなければ選択を破棄
    if (!attr?.pole) {
      sketch.undo();
      return;
    }

    // 2つ目の電柱を選んだら選択終了
    if (paths?.length >= 2) {
      sketch.complete();
    }
    return;
  }

  // 選択終了
  if (event.state === 'complete') {
    const paths = event.graphic?.geometry?.paths?.at(0);
    linkSelectComplete({ event, sketch, layers, paths, onItemSelect });
    return;
  }

  // 選択取消
  if (event.state === 'cancel') {
    console.debug(LOGH, '径間選択取消');
    setSelectMode(null);
  }
}

//
// ヒットテスト
//
async function hitTest(sketch, layers, path) {
  if (!path) return null;

  // 座標変換
  const view = sketch.view;
  const point = view.toScreen({
    type: 'point', x: path[0], y: path[1],
    spatialReference: view.spatialReference,
  });

  // ヒットテスト - 設備一覧と電柱一覧を探す
  const hit = await view.hitTest(point, {
    include: [ layers.setubi, layers.pole, layers.keikan ],
    exclude: [ sketch.layer ],
  });

  // 結果判定
  for (const result of hit.results) {
    const graphic = result.graphic;
    const type = graphic?.attributes?.type

    // 電柱を返す
    if (type === 'setubi' || type === 'pole') {
      return graphic.attributes;
    }

    // 径間を返す
    if (type === 'keikan') {
      return graphic.attributes;
    }
  }

  // ヒットテスト - 電柱マスタレイヤーを探す
  if (layers.masterView) {
    const query = layers.masterView.createQuery();
    query.geometry = {
      type: 'point', x: path[0], y: path[1],
      spatialReference: view.spatialReference,
    };
    query.distance = 10 * view.resolution;
    const result = await layers.masterView.queryFeatures(query);

    // 結果判定
    for (const feature of result.features) {
      const pole = feature.attributes;

      // 電柱を返す
      if (pole.areaCode && pole.lineCode && pole.poleNo) {
        return { pole };
      }
    }
  }
  return null;
}

//
// 径間選択確定
//
async function linkSelectComplete({
  event,
  sketch,
  layers,
  paths, onItemSelect,
}) {
  console.debug(LOGH, '径間選択終了', paths?.length);

  // 選択枠をクリア
  sketch.layer.removeAll();

  // 電柱検索
  const path1 = paths?.at(0);
  const path2 = paths?.at(1);
  const attr1 = await hitTest(sketch, layers, path1);
  const attr2 = await hitTest(sketch, layers, path2);
  if (!attr1 || !attr1.pole) return;
  if (!attr2 || !attr2.pole) return;

  // 径間選択
  const newLink = new PoleLink(
      new PoleItem(attr1.pole),
      new PoleItem(attr2.pole));
  console.info(LOGH, '径間選択', newLink);
  onItemSelect('link', newLink, { from: 'map' });
}
